// This file automatically generated. Don't commit this
import { EnvMy } from "common-library/ucountit-env"
import { Optional, Required } from "./Environment"

const config: EnvMy<Required, Optional> = {
  // Override config here
}

export default config
